import {objectFromEntries, entry} from '@benchling/js-utils';

import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

import {RegistryItemSummaryGraphQL} from '../../../graphql-fragments/registry/registry-items/__generated/RegistryItemSummaryGraphQL';

interface GraphQLGeneratedType {
  __typename: string;
}

type BIOENTITY_TYPENAME = RegistryItemSummaryGraphQL['__typename'];
export const BIOENTITY_TYPE_TO_TYPENAME: {[modelType: string]: BIOENTITY_TYPENAME} = {
  [ModelTypeConstants.BASIC_FOLDER_ITEM]: 'BasicFolderItemNode',
  [ModelTypeConstants.MIXTURE]: 'MixtureNode',
  [ModelTypeConstants.MOLECULE]: 'MoleculeNode',
  // Deliberately the canonical typename rather than both: this is a one-to-one map used to derive
  // the typename the server emits for a model type. Becomes 'AaSequenceNode' when the canonical
  // name flips (BNCH-169122).
  [ModelTypeConstants.PROTEIN]: 'ProteinNode',
  [ModelTypeConstants.SEQUENCE]: 'SequenceNode',
};

export const BIOENTITY_TYPENAME_TO_TYPE = objectFromEntries(
  Object.entries(BIOENTITY_TYPE_TO_TYPENAME).map(([key, value]) => entry(value, key))
);

// TODO (GraphQL): Replace usages of this with APIIDPrefixToTypename.
export function bioentityIdToTypename(id: string): BIOENTITY_TYPENAME {
  const modelType = APIUtil.apiIdToMaybeType(id);
  assert(
    modelType != null && modelType in BIOENTITY_TYPE_TO_TYPENAME,
    `Expected a valid Bioentity id, got the id ${id} instead.`
  );
  return BIOENTITY_TYPE_TO_TYPENAME[modelType];
}

export function isGraphQLBioentity<GenType extends GraphQLGeneratedType, NarrowedGenType extends GenType>(
  graphQLFolderItem: GenType
): graphQLFolderItem is NarrowedGenType {
  return (Object.values(BIOENTITY_TYPE_TO_TYPENAME) as Array<string>).includes(graphQLFolderItem.__typename);
}
